import { reactive, readonly, watch } from 'vue'
const axios = require('axios')

const state = reactive({
    style: { chosenIndex: 0, options: ["Motorhome / Campervan", "Caravan"] },
    categories: null, //Top level brands
    bedLayouts: null,
    dimensions: [],
    budgetRanges: null,
    results: null,
    isLoading: false,
    imageFloorPlans: true,
});

export function setLoading(isLoading) {
    state.isLoading = isLoading
}

export function setCategories(style) {
    if (style === 'caravan') {
        axios.get(`/api/caravans/categories`).then(({ data }) => (state.categories = data));  
    } else axios.get(`/api/motorhomes/categories`).then(({ data }) => state.categories = data)
}

export function setBedLayouts() {
    axios.get(`/api/bed-layouts`).then(({ data }) => state.bedLayouts = data)
}

export function setBudgetRanges() {
    axios.get(`/api/budget-ranges`).then(({ data }) => (state.budgetRanges = data));
}

export function setDimensions() {
    axios
        .get(`/api/dimensions`)
        .then(({ data }) => (state.dimensions = data));
}

watch(() => state.style.chosenIndex, chosenIndex => {
    if (chosenIndex === -1) return state.categories = null
    const style = state.style.options[chosenIndex].toLowerCase()
    setCategories(style)
})

export function setStyle(event, index) {

    setLoading(true)
    setTimeout(() => setLoading(false), 500)

    if (!event.target.checked) return state.style.chosenIndex = -1
    state.style.chosenIndex = index
}

export function toggleImage() {
    state.imageFloorPlans = !state.imageFloorPlans
}

export function submitSearch(data) {
    const formattedData = {
        ...data,
        bedLayouts: getFinalValuesForSearch(data, "bedLayouts"),
        categories: getFinalCategoryValuesForSearch(data, "categories"),
        dimensions: getFinalValuesForSearch(data, "dimensions"),
        budgetRange: data["budgetRange"],
    };

    state.isLoading = true
    axios.post('/api/search', formattedData).then(({ data }) => {
        state.results = data
        state.isLoading = false
        const el = document.getElementById('search-results')
        el?.scrollIntoView()
    })
}

function getFinalValuesForSearch(data, key) {
    return data[key]
}

function getFinalCategoryValuesForSearch(data, key) {
    if (data[key].length > 0) return data[key];
    return state[key].map((x) => x.id);
}

// function formatDimensions(id) {
//     if (id == 1) {
//         return ["<= 6000"];
//     } else if (id == 2) {
//         return ["and", ">=" + "6001", "<=" + "7000"];
//     } else if (id == 3) {
//         return [">= 7001"];
//     } else {
//         return [">= 0000"];
//     }
// }

export default readonly(state)